import React, { useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  Button,
  Box,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Backdrop,
  CircularProgress,
  FormControl,
  Select,
  Checkbox,
  MenuItem,
  InputLabel,
  TextField,
  Menu,
  Tooltip,
  InputBase,
  Typography,
  Tabs,
  Tab,
  TableContainer,
  Grid,
  InputAdornment,
  Popover,
  useTheme,
} from "@material-ui/core";

import { Link } from "react-router-dom";
import { Pagination } from "@material-ui/lab";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import { useDispatch, useSelector } from "react-redux";
import { changeShiftStatus, getBooking } from "../../store/action";
import history from "../../utils/HistoryUtils";
import Notification from "../../components/Notification/Notification";
import apiConfigs from "../../config/config";
import axios from "axios";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import { getStaffDetail, getCandidateList } from "../../store/action/staff/staffAction";
import {
  getBookingTrust,
  getExpense,
  getHospitalList,
  getWardByHospital,
} from "../../store/action/booking/bookingAction";
import { getSpecShiftCreate } from "../../store/action/specialities/specialitiesAction";
import AddExpense from "../InvoiceStudio/AddExpense";
import { notificationSuccess } from "../../store/action/notificationMsg";
import { customEnLocale } from "../../helper/customLocale";
import Loading from "../../components/Loading/Loading";

const useStyle = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.main,
  },
  container: {
    // marginTop: "15px",
    maxHeight: "calc(100vh - 260px)",
  },
}));

const SingleCandidateList = ({ match, user_id }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const tabList = [
    "CONFIRMED",
    "CANCEL",
    "PROVISIONAL",
    "COMPLETED",
    "EXPENSES"
  ];
  const displayTabList = ['BOOKED', 'CANCEL', 'PROVISIONAL', 'COMPLETED', 'EXPENSES']
  const [page, setPage] = useState(1);
  const [searchData, setSearchData] = useState({
    search: "",
    specialty: "",
    customer: "",
    site: "",
    ward: "",
    consultants: "",
    candidate: user_id,
    start_date: null,
    end_date: null,
  });
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const [activeIndex, setActiveIndex] = useState(0);
  const [bookingNotify, setBookingNotify] = useState(false);
  const [getTrustId, setTrustId] = useState();
  const [getHospitalId, setHospitalId] = useState();
  const [speciality, setSpeciality] = useState([]);
  const [trust, setTrust] = useState([]);
  const [hospitalList, setHospitalList] = useState();
  const [wardList, setWardList] = useState([]);
  const [staff, setStaff] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const { bookingItem, loading, shiftStatusSuccess } = useSelector(
    (state) => state.booking
  );
  const [activeTab, setActiveTab] = useState("");
  const [open, setOpen] = useState(false);
  const [bookingStatus, setBookingStatus] = useState({
    booking_id: "",
    status: "",
  });
  const { getExpenseItem } = useSelector((state) => state.booking);

  const [pdfData, setPdfData] = useState({
    id: [],
  });

  const trustHandleChange = (event) => {
    searchData.site = "";
    searchData.ward = "";
    setTrustId(event.target.value);
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };
  const hospitalHandleChange = (event) => {
    searchData.ward = "";
    setHospitalId(event.target.value);
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
    getWardType(event.target.value);
  };

  const getSpecialities = async () => {
    dispatch(
      getSpecShiftCreate((result) => {
        if (result?.status === true) {
          setSpeciality(result);
        }
      })
    );
  };

  const getTrust = async () => {
    dispatch(
      getBookingTrust((result) => {
        if (result?.status === true) {
          setTrust(result);
        }
      })
    );
  };
  const gethospital = async () => {
    if (getTrustId) {
      dispatch(
        getHospitalList(getTrustId, (result) => {
          if (result?.status === true) {
            setHospitalList(result);
          }
        })
      );
    }
  };
  const getWardType = async (hospitalId) => {
    dispatch(
      getWardByHospital(hospitalId, getTrustId, (result) => {
        if (result?.status === true) {
          setWardList(result);
        }
      })
    );
  };
  const getStaff = async () => {
    dispatch(
      getStaffDetail((result) => {
        if (result?.data) {
          setStaff(result);
        }
      })
    );
  };

  const getExpenseData = async (user_id) => {
    dispatch(
      getExpense(user_id)
    );
  };

  const getCandidates = async () => {
    dispatch(
      getCandidateList((result) => {
        if (result?.data) {
          setCandidates(result);
        }
      })
    );
  };

  const getBookingList = (
    pageNo = 1,
    search = "",
    status = "CONFIRMED",
    specialty = "",
    customer = "",
    site = "",
    ward = "",
    consultants = "",
    candidate = user_id,
    start_date = "",
    end_date = ""
  ) => {

    dispatch(

      getBooking({
        pageNo,
        search,
        status,
        specialty,
        customer,
        site,
        ward,
        consultants,
        candidate,
        start_date,
        end_date,
      })
    );
  };

  const onhandlClick = (id) => {
    history.push(`/admin/bookings/${id}/detail`);
  };

  const handleChangePage = (pageNo, value) => {
    let status = tabList[activeIndex];
    setPage(value);
    setPdfData(pdfData);
    setTimeout(
      getBookingList(
        value,
        searchData.search,
        status,
        searchData?.specialty,
        searchData?.customer,
        searchData?.site,
        searchData?.ward,
        searchData?.consultants,
        searchData?.candidate,
        searchData?.start_date === null ? "" : searchData?.start_date,
        searchData?.end_date === null ? "" : searchData?.start_date
      ),
      2000
    );
  };

  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    let status = tabList[activeIndex];
    if (d1) {
      setTimeout(
        getBookingList(
          page,
          d1,
          status,
          searchData?.specialty,
          searchData?.customer,
          searchData?.site,
          searchData?.ward,
          searchData?.consultants,
          searchData?.candidate,
          searchData?.start_date === null
            ? ""
            : moment(searchData?.start_date).format("DD-MM-yyyy"),
          searchData?.end_date === null
            ? ""
            : moment(searchData?.end_date).format("DD-MM-yyyy")
        ),
        100
      );
    } else {
      setTimeout(
        getBookingList(
          page,
          "",
          status,
          searchData?.specialty,
          searchData?.customer,
          searchData?.site,
          searchData?.ward,
          searchData?.consultants,
          searchData?.candidate,
          searchData?.start_date === null
            ? ""
            : moment(searchData?.start_date).format("DD-MM-yyyy"),
          searchData?.end_date === null
            ? ""
            : moment(searchData?.end_date).format("DD-MM-yyyy")
        ),
        100
      );
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };
  const handleClickSearch = (event, value) => {

    let status = tabList[activeIndex];
    setPage(value);
    handleMenuClose(true);
    setTimeout(
      getBookingList(
        page,
        searchData.search,
        status,
        searchData?.specialty,
        searchData?.customer,
        searchData?.site,
        searchData?.ward,
        searchData?.consultants,
        searchData?.candidate,
        searchData?.start_date === null
          ? ""
          : moment(searchData?.start_date).format("DD-MM-yyyy"),
        searchData?.end_date === null
          ? ""
          : moment(searchData?.end_date).format("DD-MM-yyyy")
      ),
      1000
    );

  };

  const handleReset = () => {
    let status = tabList[activeIndex];
    let data = {
      search: "",
      specialty: "",
      candidate: user_id,
      customer: "",
      site: "",
      ward: "",
      consultants: "",
      start_date: null,
      end_date: null,
    };
    setSearchData(data);
    handleMenuClose(true);
    setTimeout(getBookingList(page, "", status), 100);
  };

  useEffect(() => {
    getBookingList();
    getSpecialities();
    getTrust();
    getStaff();
    getCandidates();
    if (user_id) {
      getExpenseData(user_id);
    }
  }, [user_id]);

  useEffect(() => {
    if (getTrustId) {
      gethospital();
    }
  }, [getTrustId]);

  const tabChange = (index, list) => {
    pdfData.id = []
    setPage(1);
    setSearchData({ ...searchData });
    setActiveIndex(index);
    setActiveTab(list);
    setTimeout(
      getBookingList(
        1,
        searchData?.search,
        list,
        searchData?.specialty,
        searchData?.customer,
        searchData?.site,
        searchData?.ward,
        searchData?.consultants,
        searchData?.candidate,
        searchData?.start_date === null
          ? ""
          : moment(searchData?.start_date).format("DD-MM-yyyy"),
        searchData?.end_date === null
          ? ""
          : moment(searchData?.end_date).format("DD-MM-yyyy")
      ),
      100
    );
  };

  const downloadPdf = async (booking_id, reference_id) => {
    setLoadings(true);
    const getToken = localStorage.getItem("token")
      ? localStorage.getItem("token").replace(/['"]+/g, "")
      : "";
    await axios
      .get(
        `${apiConfigs.API_URL}api/organization/generate-invoice/${booking_id}`,
        {
          headers: {
            Authorization: getToken ? `Bearer ${getToken}` : "",
          },
          responseType: "blob",
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", reference_id + ".pdf");
        document.body.appendChild(link);
        link.click();
        setLoadings(false);
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const dublicateBooking = async (paymentSchemeId) => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    await axios
      .get(
        `${apiConfigs.API_URL}api/organization/dublicate-booking/${paymentSchemeId}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status === true) {
          dispatch(notificationSuccess(response?.data?.message));
          setTimeout(() => {
            getBookingList();
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("error.message", error.message);
      });
  };
  const multipleInvoiceDownload = async () => {
    setLoadings(true);
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    axios
      .post(`${apiConfigs.API_URL}api/organization/multiple-invoice`, pdfData, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Invoice.pdf");
        document.body.appendChild(link);
        link.click();
        setLoadings(false);
      })
      .catch((error) => {
        // setTimesheetError("Sorry timesheet upload failed");
      });
  };
  const handleCheckboxClick = (event, ids) => {
    const multiplePdf = JSON.parse(JSON.stringify(pdfData));
    const isChecked = event.target.checked;
    if (isChecked) {
      multiplePdf.id.push(parseFloat(ids));
      setPdfData(multiplePdf);
    } else {
      const newData = multiplePdf.id.filter((item) => item !== parseFloat(ids));
      multiplePdf.id = newData;
      setPdfData(multiplePdf);
    }
  };
  const handleCheckboxAllClick = (event) => {
    const multiplePdf = JSON.parse(JSON.stringify(pdfData));
    const isChecked = event.target.checked;
    if (isChecked && bookingItem?.data?.data.length > 0) {
      const createArray = [];
      bookingItem?.data?.data.map((row, index) => {
        createArray.push(row.id);
      })
      multiplePdf.id = createArray;
      setPdfData(multiplePdf);
    } else {
      multiplePdf.id = [];
      setPdfData(multiplePdf);
    }

  };
  useEffect(() => {
    if (bookingStatus.booking_id !== "") {
      dispatch(changeShiftStatus(bookingStatus));
      setBookingNotify(true);
      setTimeout(() => {
        getBookingList();
      }, 4000);
    }
  }, [bookingStatus]);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  let loggedInRole = localStorage.getItem("role");
  loggedInRole = loggedInRole && loggedInRole.replace(/['"]+/g, "");

  const handleClickOpen = (id) => {
    setOpen(true);
  };

  const handleClose = (action) => {
    setOpen(false);
  };
  const theme = useTheme();
  return (
    <>
      {loading && <Loading open={loading} />}

      {loadings && <Loading open={loadings} />}

      {bookingNotify && shiftStatusSuccess?.message && (
        <Notification data={shiftStatusSuccess?.message} status="success" />
      )}

      <Paper>
        <Grid container alignItems="center" justifyContent="space-between" spacing={2} mb={2} className={classes.root}>
          {/* <Grid item>
            <Typography variant="h5">Booking list</Typography>
          </Grid> */}

          {/* Tabs - will take up remaining space */}
          <Grid item xs>
            <Tabs
              value={Math.abs(activeIndex)}
              onChange={(e, index) => tabChange(index, tabList[index])}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
            >
              {tabList.map((list, index) => (
                <Tab key={index + 888} label={displayTabList[index].toLowerCase()} />
              ))}
            </Tabs>
          </Grid>


          {/* Search and other controls */}
          <Grid item>
            <Grid container display="flex" alignItems="center" spacing={1}>
              <Grid item>
                {/* Search Field */}
                <TextField
                  size="small"
                  placeholder="Search now..."
                  name="search"
                  variant="outlined"
                  onChange={handleSearchChange}
                  onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon
                          style={{
                            color: "text.secondary", // Icon color
                            cursor: "pointer",
                          }}
                          onClick={handleClickSearch}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item>
                {/* Filter Button */}
                <Tooltip title="Filters">
                  <Button onClick={handleMenu} variant="outlined" color="primary">
                    <FilterListIcon />
                  </Button>
                </Tooltip>
              </Grid>

              {/* Filter Popover */}
              <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                className="filterBookingSearch"
                id="menu-appbar"
                getContentAnchorEl={null}
              >
                <Grid container spacing={2} p={2}>
                  {/* Specialty */}
                  <Grid item xs={6} md={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Specialty</InputLabel>
                      <Select name="specialty"
                        value={searchData?.specialty}
                        onChange={(e) =>
                          setSearchData({
                            ...searchData,
                            [e.target.name]: e.target.value,
                          })
                        }>
                        <MenuItem value="">Select Specialty</MenuItem>
                        {speciality?.data?.map((item) => (
                          <MenuItem key={item.id} value={item.id}>{item.speciality_name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Customer */}
                  <Grid item xs={6} md={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Customer</InputLabel>
                      <Select name="customer" value={searchData?.customer} onChange={trustHandleChange}>
                        <MenuItem value="">Select Customer</MenuItem>
                        {trust?.data?.map((t) => (
                          <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Site */}
                  <Grid item xs={6} md={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Site</InputLabel>
                      <Select name="site" value={searchData?.site} onChange={hospitalHandleChange}>
                        <MenuItem value="">Select Site</MenuItem>
                        {hospitalList?.data?.map((h) => (
                          <MenuItem key={h.id} value={h.id}>{h.hospital_name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Ward */}
                  <Grid item xs={6} md={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Ward</InputLabel>
                      <Select name="ward" value={searchData?.ward} onChange={(e) =>
                        setSearchData({
                          ...searchData,
                          [e.target.name]: e.target.value,
                        })
                      }>
                        <MenuItem value="">Select Ward</MenuItem>
                        {wardList?.data?.map((w) => (
                          <MenuItem key={w.id} value={w.id}>{w.ward_name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Consultants */}
                  <Grid item xs={6} md={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Consultants</InputLabel>
                      <Select name="consultants" value={searchData?.consultants} onChange={(e) =>
                        setSearchData({
                          ...searchData,
                          [e.target.name]: e.target.value,
                        })
                      }>
                        <MenuItem value="">Select Consultants</MenuItem>
                        {staff?.data?.map((s) => (
                          <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Date Pickers */}
                  <Grid item xs={6} md={3}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale} localeText={{ start: "Check-in", end: "Check-out" }}>
                      <DatePicker
                        label="Start Date"
                        value={searchData?.start_date}
                        onChange={(date) => setSearchData({ ...searchData, start_date: date })}
                        renderInput={(params) => <TextField {...params} fullWidth variant="outlined" />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale} localeText={{ start: "Check-in", end: "Check-out" }}>
                      <DatePicker
                        label="End Date"
                        value={searchData?.end_date}
                        onChange={(date) => setSearchData({ ...searchData, end_date: date })}
                        renderInput={(params) => <TextField {...params} fullWidth variant="outlined" />}
                      />
                    </LocalizationProvider>
                  </Grid>

                  {/* Search / Reset */}
                  <Grid container xs={12} md={3} alignItems="center" justifyContent="flex-end" spacing={1}>
                    <Grid item>
                      <Button variant="contained" color="secondary" onClick={handleClickSearch}>Search</Button>
                    </Grid>
                    <Grid item>
                      <Button variant="outlined" onClick={handleReset}>Reset</Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Menu>

              <Grid item>
                {/* Add Expense */}
                {activeTab === "EXPENSES" &&
                  <Button variant="contained" color="secondary" onClick={handleClickOpen}>Add Expense</Button>
                }
              </Grid>

              {pdfData.id.length > 0 && (
                <Grid item>
                  <Button variant="contained" color="secondary" onClick={multipleInvoiceDownload} startIcon={<span className="material-icons">download</span>}>
                    Download PDF
                  </Button>
                </Grid>
              )}

            </Grid>
          </Grid>
        </Grid>


        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              {activeTab === "EXPENSES" ? (
                <TableRow>
                  <TableCell align="left">Type of Expense</TableCell>
                  <TableCell align="left">Expense Unit</TableCell>
                  <TableCell align="left">Pay Rate</TableCell>
                  <TableCell align="left">Charge Rate</TableCell>
                  <TableCell align="left">Amount Paid</TableCell>
                  <TableCell align="left">Amount Charged</TableCell>
                  <TableCell align="left">Booking Refs.</TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  {activeIndex === 4 && (
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={
                          bookingItem?.data?.data?.length > 0 &&
                          pdfData.id.length === bookingItem.data.data.length
                        }
                        onClick={handleCheckboxAllClick}
                      />
                    </TableCell>
                  )}
                  <TableCell style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Id</TableCell>
                  <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Customer Name</TableCell>
                  <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Site Name</TableCell>
                  <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Ward Name</TableCell>
                  <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Grade</TableCell>
                  <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Date</TableCell>
                  {activeIndex === 4 && <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Invoice Date</TableCell>}
                  <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Shift Time</TableCell>
                  <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Created By</TableCell>
                  {activeIndex === 0 && <TableCell align="center" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Duplicate</TableCell>}
                  {activeIndex === 4 && <TableCell align="center" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Invoice</TableCell>}
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              )}
            </TableHead>

            <TableBody>
              {activeTab === "EXPENSES" ? (
                <>
                  {getExpenseItem?.data?.length > 0 ? (
                    getExpenseItem.data.map((expense, index) => (
                      <TableRow key={index}>
                        <TableCell>{expense.expense_type}</TableCell>
                        <TableCell>{expense.expense_unit}</TableCell>
                        <TableCell>{expense.pay_rate}</TableCell>
                        <TableCell>{expense.charge_rate}</TableCell>
                        <TableCell>{expense.amount_paid}</TableCell>
                        <TableCell>{expense.amount_charged}</TableCell>
                        <TableCell>{expense.booking_ref || "N/A"}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        Sorry, Expenses not available!
                      </TableCell>
                    </TableRow>
                  )}
                </>
              ) : (
                <>
                  {bookingItem?.data?.data?.length > 0 ? (
                    bookingItem.data.data.map((row, index) => {
                      let userRole = bookingItem?.data?.data[0]?.loggedUserDesignation?.replace(/['"]+/g, "");
                      const dateFormate = row.date.toString().split("-").reverse().join("-");
                      let newdate = "";
                      if (row.invoice_date) {
                        const [datePart, timePart] = row.invoice_date.split(" ");
                        const [y, m, d] = datePart.split("-");
                        newdate = `${d}-${m}-${y} ${timePart}`;
                      }

                      return (
                        <TableRow key={row.id || index}>
                          {activeIndex === 4 && (
                            <TableCell padding="checkbox">
                              <Checkbox
                                value={row.id}
                                checked={pdfData.id.includes(row.id)}
                                onClick={(event) => handleCheckboxClick(event, row.id)}
                              />
                            </TableCell>
                          )}
                          <TableCell>{bookingItem?.data?.from + index}</TableCell>
                          <TableCell>{row.name}</TableCell>
                          <TableCell>{row.hospital_name}</TableCell>
                          <TableCell>{row.ward_name}</TableCell>
                          <TableCell>{row.grade_name}</TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }}>{dateFormate}</TableCell>
                          {activeIndex === 4 && <TableCell>{newdate}</TableCell>}
                          <TableCell>
                            {row.start_time} - {row.end_time}
                          </TableCell>
                          <TableCell>{row.createdByName}</TableCell>

                          {activeIndex === 0 && (
                            <TableCell align="center">
                              <Link to="#" onClick={() => dublicateBooking(row.id)}>
                                <FileCopyOutlinedIcon />
                              </Link>
                            </TableCell>
                          )}

                          {activeIndex === 4 && (
                            <TableCell align="center">
                              {(loggedInRole === "ORGANIZATION" || userRole === "Admin" || userRole === "Finance") ? (
                                <Link
                                  to="#"
                                  onClick={() => downloadPdf(row.id, row.invoice_number)}
                                  className="btn btn-secondary"
                                >
                                  Download
                                </Link>
                              ) : (
                                <Button variant="contained" disabled>
                                  Download
                                </Button>
                              )}
                            </TableCell>
                          )}

                          <TableCell align="center">
                            <Button
                              variant="contained"
                              onClick={() => onhandlClick(row.id)}
                              color="secondary"
                            >
                              View
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={activeIndex === 4 ? 12 : activeIndex === 0 ? 10 : 9} align="center">
                        Sorry, booking not available!
                      </TableCell>
                    </TableRow>
                  )}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Grid container className="mt-5" justifyContent="flex-end" className={classes.root}>
          <Pagination
            onChange={handleChangePage}
            page={page}
            count={bookingItem?.data?.last_page}
            showFirstButton
            showLastButton
          />
        </Grid>
      </Paper>
      <AddExpense open={open} handleClose={handleClose} type={"candidate-bookinglist"} candidateId={user_id} setActiveTab={() => setActiveTab("EXPENSES")} />
    </>
  );
};

export default SingleCandidateList;
